import React, { useState, useEffect, useContext } from "react";
import { Form, Row, Col, Button, Table, Card, InputGroup } from 'react-bootstrap'
import { FaRegEyeSlash, FaEye ,FaRegEye, FaSchool, FaEdit } from 'react-icons/fa'
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Profile = () => {
      const navigate = useNavigate();
      const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
      const [currentPassword, setCurrentPassword] = useState("");
      const [newPassword, setNewPassword] = useState("");
      const [confirmPassword ,setConfirmPassword] = useState("");
      const [errors, setErrors] = useState({});
      const [showPassword, setShowPassword] = useState({
        currentPassword: false,
        newPassword: false,
        confirmPassword: false,
      });
       const authToken = process.env.REACT_APP_authToken;
       const { accessToken, logout,data } = useContext(UserContext);
       const headers = {
         "auth-token": authToken,
         authorization: accessToken,
       };
       
       const [load, setLoad] = useState(false);
      const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({
          ...prev,
          [field]: !prev[field],
        }));
      };
      const handlePasswordChange = (e) => {
        const { name, value } = e.target;
      
        // Update the corresponding state
        if (name === "currentPassword") {
          setCurrentPassword(value);
        } else if (name === "newPassword") {
          setNewPassword(value);
        } else if (name === "confirmPassword") {
          setConfirmPassword(value);
        }
      
        // Clear the error for the specific field if it exists
        if (errors[name]) {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        }
      };
      const validate = () => {
        const errors = {};
      
        if (!currentPassword) {
          errors.currentPassword = "Current password is required.";
        } else if (currentPassword.length < 6) {
            errors.currentPassword = "Password must be at least 6 characters.";
          } else if (currentPassword.length > 20) {
            errors.currentPassword = "Password must not exceed 20 characters.";
          }
      
        if (!newPassword) {
          errors.newPassword = "New password is required.";
        } else if (newPassword.length < 6) {
            errors.newPassword = "Password must be at least 6 characters.";
          } else if (newPassword.length > 20) {
            errors.newPassword = "Password must not exceed 20 characters.";
          }
      
        if (!confirmPassword) {
          errors.confirmPassword = "Please confirm your new password.";
        } else if (confirmPassword !== newPassword) {
          errors.confirmPassword = "Passwords do not match.";
        }
      
        setErrors(errors);
        return Object.keys(errors).length === 0;
      };
      
      const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);

        if (validate()) {

            const payload = {
            "new_password":newPassword,
            "current_password":currentPassword
            }
          const res = await APIServices.post(
            "admin/change_password",
            payload,
            headers
          );
          if (res?.data?.status === true) {
            setLoad(false);
            let data = res?.data;
        
            showToast(res?.data?.message || "Success", "success");
            setTimeout(() => {
              navigate("/admin/dashboard");
            }, 2000);
          } else {
            showToast(res?.data?.message || "Something went wrong.", "error");
            setLoad(false);
          }
        }
        setLoad(false);
      };
      const showToast = (message, type) => {
        toast(message, {
          position: "top-right",
          autoClose: 2000,
          type,
          hideProgressBar: false,
          closeOnClick: true,
        });
      };
    return (
        <>
            <div className='profile_sec'>
                <h1 className='font_blue_18 font-600 mb-3'>Profile</h1>

                {data?.user_type === "school" && data?.school && (
                    <div className="school_info mb-4">
                        <Row>
                            <Col md={12}>
                                <div className="school-detail-card" style={{
                                    background: '#fff',
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                    padding: '24px'
                                }}>
                                    <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                                        <div className="d-flex align-items-center gap-4">
                                            <div style={{
                                                width: '80px',
                                                height: '80px',
                                                borderRadius: '12px',
                                                overflow: 'hidden',
                                                flexShrink: 0,
                                                background: '#f5f5f5',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                {data?.school?.logo ? (
                                                    <img src={data?.school?.logo} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                ) : (
                                                    <FaSchool size={32} color="#999" />
                                                )}
                                            </div>
                                            <div>
                                                <h4 className="mb-1" style={{ color: '#1e3a5f' }}>{data?.school?.school_name}</h4>
                                            </div>
                                        </div>
                                        <Button 
                                            variant="primary" 
                                            className="d-flex align-items-center gap-2"
                                            onClick={() => navigate(`/admin/profile/edit/${data?.school?.id}`)}
                                        >
                                            <FaEdit /> Edit
                                        </Button>
                                    </div>
                                    
                                    <Row>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">School Code</span>
                                                <span className="info-value">{data?.school?.school_code || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Registration Number</span>
                                                <span className="info-value">{data?.school?.registration_number || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">School Type</span>
                                                <span className="info-value">{data?.school?.school_type || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Established Year</span>
                                                <span className="info-value">{data?.school?.established_year || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Email</span>
                                                <span className="info-value">{data?.email || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Mobile</span>
                                                <span className="info-value">{data?.country_code} {data?.mobile || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Fax</span>
                                                <span className="info-value">{data?.school?.fax || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Website</span>
                                                <a 
                                                    href={data?.school?.website && data.school.website.startsWith('http') ? data.school.website : `https://${data?.school?.website}`} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="info-value text-decoration-none"
                                                    style={{ color: '#0d6efd' }}
                                                >
                                                    {data?.school?.website || 'N/A'}
                                                </a>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Address</span>
                                                <span className="info-value">{data?.school?.address || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">City</span>
                                                <span className="info-value">{data?.school?.city_name || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">State</span>
                                                <span className="info-value">{data?.school?.state_name || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Country</span>
                                                <span className="info-value">{data?.school?.country_name || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Zip Code</span>
                                                <span className="info-value">{data?.school?.zip_code || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Total Students</span>
                                                <span className="info-value">{data?.school?.no_of_student || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Total Teachers</span>
                                                <span className="info-value">{data?.school?.no_of_teacher || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Social Links</span>
                                                <div className="mt-1">
                                                    {data?.school?.social_link ? (
                                                        data.school.social_link.split(',').map((link, index) => {
                                                            const url = link.trim();
                                                            return (
                                                                <div key={index} className="mb-1">
                                                                    <a 
                                                                        href={url.startsWith('http') ? url : `https://${url}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{ color: '#0d6efd', textDecoration: 'none' }}
                                                                    >
                                                                        {url.replace(/^https?:\/\//, '')}
                                                                    </a>
                                                                </div>
                                                            );
                                                        })
                                                    ) : (
                                                        <span className="info-value">N/A</span>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={12} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Grades</span>
                                                <div className="mt-1">
                                                    {data?.school?.grade_names && data?.school?.grade_names.length > 0 ? (
                                                        data.school.grade_names.map((grade, index) => (
                                                            <span key={index} className="badge bg-info me-1 mb-1">{grade}</span>
                                                        ))
                                                    ) : (
                                                        <span className="info-value">{data?.school?.grade || 'N/A'}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>

                                        {data?.school?.contact_persons && data?.school?.contact_persons.length > 0 && (
                                            <Col md={12} className="mt-3">
                                                <h5 className="mb-3" style={{ color: '#1e3a5f' }}>Contact Persons</h5>
                                                <Row>
                                                    {data.school.contact_persons.map((contact, index) => (
                                                        <Col md={6} key={index} className="mb-3">
                                                            <div className="contact-card" style={{
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                padding: '16px',
                                                                border: '1px solid #e9ecef'
                                                            }}>
                                                                <div className="info-item">
                                                                    <span className="info-label">Name</span>
                                                                    <span className="info-value">{contact.name || 'N/A'}</span>
                                                                </div>
                                                                <div className="info-item mt-2">
                                                                    <span className="info-label">Designation</span>
                                                                    <span className="info-value">{contact.designation || 'N/A'}</span>
                                                                </div>
                                                                <div className="info-item mt-2">
                                                                    <span className="info-label">Email</span>
                                                                    <span className="info-value">{contact.email || 'N/A'}</span>
                                                                </div>
                                                                <div className="info-item mt-2">
                                                                    <span className="info-label">Phone</span>
                                                                    <span className="info-value">{contact.phone || 'N/A'}</span>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Col>
                                        )}
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <style>{`
                            .info-item {
                                display: flex;
                                flex-direction: column;
                            }
                            .info-label {
                                font-size: 12px;
                                color: #6c757d;
                                font-weight: 500;
                                margin-bottom: 4px;
                            }
                            .info-value {
                                font-size: 14px;
                                color: #1e3a5f;
                                font-weight: 600;
                            }
                        `}</style>
                    </div>
                )}

                 {data?.user_type !== "school" && (
                    <div className="user_info mb-4">
                        <Row>
                            <Col md={12}>
                                <div className="user-detail-card" style={{
                                    background: '#fff',
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                    padding: '24px'
                                }}>
                                    <div className="d-flex align-items-center gap-4 mb-4">
                                        <div style={{
                                            width: '80px',
                                            height: '80px',
                                            borderRadius: '50%',
                                            overflow: 'hidden',
                                            flexShrink: 0,
                                            background: '#f5f5f5',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            {data?.profile_pic ? (
                                                <img src={data?.profile_pic} alt="profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            ) : (
                                                <FaSchool size={32} color="#999" />
                                            )}
                                        </div>
                                        <div>
                                            <h4 className="mb-1" style={{ color: '#1e3a5f' }}>{data?.fullname || 'N/A'}</h4>
                                        </div>
                                    </div>
                                    
                                    <Row>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Name</span>
                                                <span className="info-value">{data?.fullname || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Email</span>
                                                <span className="info-value">{data?.email || 'N/A'}</span>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="info-item">
                                                <span className="info-label">Mobile</span>
                                                <span className="info-value">{data?.country_code} {data?.mobile || 'N/A'}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <style>{`
                            .info-item {
                                display: flex;
                                flex-direction: column;
                            }
                            .info-label {
                                font-size: 12px;
                                color: #6c757d;
                                font-weight: 500;
                                margin-bottom: 4px;
                            }
                            .info-value {
                                font-size: 14px;
                                color: #1e3a5f;
                                font-weight: 600;
                            }
                        `}</style>
                    </div>
                )}

                <div className='change_password'>
                    <h2 className='font_blue_18 font-600 mb-2'>Change Password</h2>

                    <form>
                        <Row>
                            <Col md={4} lg={4}>
                                <Form.Group controlId="currentPassword">
                                    <Form.Label className="font_blue_14 font-500 mb-2 ">Current Password</Form.Label>
                                    <InputGroup>
                                   <Form.Control
                                     type={showPassword.currentPassword ? "text" : "password"}
                                     name="currentPassword"
                                     placeholder="Enter Current Password"
                                     value={currentPassword}
                                     onChange={handlePasswordChange}
                                   />
                                   <InputGroup.Text variant="outline-secondary"
                                      onClick={() => togglePasswordVisibility("currentPassword")}
                                   >
                                     {showPassword.currentPassword ? <FaRegEye />: <FaRegEyeSlash />}
                                   </InputGroup.Text>
                                 </InputGroup>
                                 {errors.currentPassword && <div className="text-danger mt-2">{errors.currentPassword}</div>}
                                </Form.Group>
                            </Col>

                            <Col md={4} lg={4}>
                                <Form.Group controlId="newPassword">
                                    <Form.Label className="font_blue_14 font-500 mb-2 ">New Password</Form.Label>
                                    <InputGroup>
                                   <Form.Control
                                     type={showPassword.newPassword ? "text" : "password"}
                                     name="newPassword"
                                     placeholder="Enter New Password"
                                     value={newPassword}
                                     onChange={handlePasswordChange}
                                   />
                                   <InputGroup.Text
                                     onClick={() => togglePasswordVisibility("newPassword")}
                                   >
                                     {showPassword.newPassword ? <FaRegEye />: <FaRegEyeSlash />}
                                   </InputGroup.Text>
                                 </InputGroup>
                                 {errors.newPassword && <div className="text-danger mt-2">{errors.newPassword}</div>}
                                </Form.Group>
                            </Col>

                            <Col md={4} lg={4}>
                                <Form.Group controlId="confirmPassword">
                                    <Form.Label className="font_blue_14 font-500 mb-2 ">Confirm New Password</Form.Label>
                                    <InputGroup>
                                     <Form.Control
                                     type={showPassword.confirmPassword ? "text" : "password"}
                                     name="confirmPassword"
                                     placeholder="Enter Confirm New Password"
                                     value={confirmPassword}
                                     onChange={handlePasswordChange}
                                   />
                                   <InputGroup.Text
                                      onClick={() => togglePasswordVisibility("confirmPassword")}
                                   >
                                     {showPassword.confirmPassword ? <FaRegEye />: <FaRegEyeSlash />}
                                   </InputGroup.Text>
                                 </InputGroup>
                                 {errors.confirmPassword && <div className="text-danger mt-2">{errors.confirmPassword}</div>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end gap-2 mt-3">
                            <Button className="btn blue_border"onClick={() =>navigate("/admin/dashboard")}>Cancel</Button>
                            <Button className="btn red_button"  onClick={handleSubmit}   disabled={load} >
                             {load ? "Processing..." : "Update"}</Button>
                        </div>
                    </form>

                </div>

            </div>
                  <ToastContainer />
            
        </>
    )
}

export default Profile